<template>
    <el-dialog
        :visible.sync="detail.dialog"
        custom-class="dailogCustomerBase"
        width="50%"
    >
        <template slot="title">
            <h1 class="text-header">สร้างแพ็กเกจ</h1>
        </template>
        <form-create-qr-payment
            :isCreate.sync="detail.isCreate"
            :generateQrPaymentParam.sync="generateQrPaymentParam"
            :clearPriceData.sync="clearPriceData"
        ></form-create-qr-payment>
        <span
            slot="footer"
            class="dialog-footer"
        >
            <el-button @click="cancelForm()">ยกเลิก</el-button>
            <el-button type="primary" @click="checkForm()">บันทึก</el-button>
        </span>
    </el-dialog>
</template>

<script>
import fgApi from '@/services/fillgoods'
import FormCreateQrPayment from './FormCreateQrPayment.vue'
export default {
    name: 'createQrPayment',
    components: {
        FormCreateQrPayment
    },
    props: {
        detail: {
            type: Object
        }
    },
    data () {
        return {
            user: this.$store.get('user/objUser'),
            generateQrPaymentParam: [],
            clearPriceData: false
        }
    },
    methods: {
        cancelForm () {
            this.clearPriceData = false
            this.$swal({
                title: 'ออกจากหน้านี้',
                text: 'คุณต้องการออกจากหน้านี้โดยไม่บันทึกข้อมูลใช่หรือไม่',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'ไม่ใช่',
                confirmButtonText: 'ใช่',
                reverseButtons: true,
                iconHtml: `<img src="${require('@/assets/swal-icons/status.svg')}" />`,
                customClass: {
                    container: 'oms-swal'
                }
            }).then(val => {
                if (val.isConfirmed) {
                    this.clearPriceData = true
                    this.detail.dialog = false
                }
            })
        },
        checkForm () {
            const invalidCycles = 0
            const invalidDiscountAmount = -1
            if (this.generateQrPaymentParam.cycles === invalidCycles || this.generateQrPaymentParam.discountAmount === invalidDiscountAmount) {
                this.$message.error('บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
            } else {
                this.saveForm()
            }
        },
        saveForm () {
            this.$swal({
                title: 'บันทึกข้อมูล',
                text: 'กรุณาตรวจสอบข้อมูลให้ถูกต้อง เมื่อบันทึกแล้วจะไม่สามารถแก้ไขข้อมูลได้',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'ดูข้อมูล',
                confirmButtonText: 'บันทึก',
                reverseButtons: true,
                iconHtml: `<img src="${require('@/assets/swal-icons/status.svg')}" />`,
                customClass: {
                    container: 'oms-swal'
                }
            }).then(val => {
                if (val.isConfirmed) {
                    this.clearPriceData = false
                    this.generateQrPayment()
                }
            })
        },
        async generateQrPayment () {
            let param = {
                userId: this.detail.userId,
                subscriptionPackageId: this.generateQrPaymentParam.param.subscriptionPackageId,
                discountAmount: this.generateQrPaymentParam.param.discountAmount,
                haveWht: this.generateQrPaymentParam.param.haveWht,
                cycles: this.generateQrPaymentParam.param.cycles,
                createdBy: this.user.email
            }
            try {
                let res = await fgApi.payment.generateQrPayment(param)
                if (res.status === 'success') {
                    this.$message.success('บันทึกข้อมูลสำเร็จ')
                    this.detail.dialog = false
                    this.clearPriceData = true
                    this.$emit('fetchHistoryList', true)
                } else {
                    this.$message.error('บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
                }
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.text-header {
    margin:unset;
    text-align:left;
}
::v-deep .divider-dash {
    border: 1px dashed #D1D5E0;
    background-color: transparent !important;
}
</style>
<style lang="scss">
.dailogCustomerBase {
    .el-dialog__header {
        background-color: teal;
        color: white;
        button {
            font-size: large;
            i {
                color: #ffffff;
                &:hover {
                    color: white;
                }
            }
        }
    }
    .el-dialog__footer {
        width: 90%;
    }
}
.mb-16 {
    margin-bottom: 16px;
}
</style>
